function _id(id) {
  return document.getElementById(id);
}

const firstName = _id("customer_fist_name");
const lastName = _id("customer_last_name");
const email = _id("customer_email");
const phoneNumberInput = _id("customer_phone_number");
const birthday = _id('customer_birthday');
const submitBtn = _id("register-form-submit-btn");
const errMessage = _id("register-error-message");
const registerForm = _id("register-form");
const otpForm = _id("otp-form");

const requiredInputs = [firstName, lastName, phoneNumberInput];

requiredInputs.forEach((input) => {
  input.addEventListener("input", () => {
    submitBtn.disabled =
      requiredInputs.some((input) => input.value.trim() === "") ||
      phoneNumberInput.value.length !== 13;
      input.classList.remove("invalid");
      errMessage.innerText = "";
  });
});

const validation = (submit) => {
  if (!firstName.value.length) {
    return firstName.classList.add("invalid");
  }
  if (!lastName.value.length) {
    return lastName.classList.add("invalid");
  }
  if (!phoneNumberInput.value.length || phoneNumberInput.value.length !== 13) {
    return phoneNumberInput.classList.add("invalid");
  }

  submit();
};

submitBtn.addEventListener("click", (e) => {
  e.preventDefault();
  validation(register);
});

const register = async () => {
  submitBtn.disabled = true;
  const body = {
    first_name: firstName.value,
    last_name: lastName.value,
    phone: phoneNumberInput.value,
    email: email.value,
    birthday: birthday.value,
  };
  console.log('customer body', body);

  const config = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  const res = await fetch(
    `${window.origin}/apps/yvesrocher/customer/register`,
    config
  );
  const data = await res.json();
  submitBtn.disabled = false;

  if (res.ok) {
    registerForm.style.display = "none";
    otpForm.style.display = "block";
  } else {
    errMessage.innerText = data.data.message;
  }
};
